import { z } from 'zod';

export const inquiryRegistrationSchema = z.object({
  title: z
    .string()
    .nonempty({ message: '제목을 확인해주세요.' })
    .min(2, { message: '2자 이상이어야 합니다.' }),
  question: z
    .string()
    .nonempty({ message: '내용을 확인해주세요.' })
    .min(2, { message: '2자 이상이어야 합니다.' }),
});
